import { Link } from "react-router-dom";
import { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setEmail("");
    alert("¡Gracias por suscribirse a nuestro boletín!");
  };

  return (
    <footer className="bg-[#1A3A52] relative overflow-hidden">
      {/* Patrón de fondo sutil */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
            backgroundSize: "60px 60px",
          }}
        ></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          {/* Columna 1 - Marca */}
          <div>
            <img
              src="/logo_irm.png"
              alt="IRM Logo"
              className="h-12 mb-4 brightness-0 invert"
            />
            <p className="text-blue-100 mb-6 text-sm">
              Su aliado estratégico en logística
            </p>
            <form onSubmit={handleNewsletterSubmit} className="flex">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Su email"
                required
                className="flex-1 px-4 py-2 bg-transparent border border-white/40 rounded-l-lg text-white placeholder-white/60 focus:outline-none focus:border-white text-sm"
              />
              <button
                type="submit"
                className="px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-r-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-fill"></i>
              </button>
            </form>
          </div>

          {/* Columna 2 - Servicios */}
          <div>
            <h3 className="text-white font-bold mb-4 text-lg">Servicios</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/servicios"
                  className="text-blue-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Ingeniería
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className="text-blue-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Repuestos
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className="text-blue-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Mantenimiento Preventivo
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  className="text-blue-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Mantenimiento Correctivo
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 3 - Empresa */}
          <div>
            <h3 className="text-white font-bold mb-4 text-lg">Empresa</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/nosotros"
                  className="text-blue-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Nosotros
                </Link>
              </li>
              <li>
                <Link
                  to="/nosotros"
                  className="text-blue-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Valores
                </Link>
              </li>
              <li>
                <Link
                  to="/nosotros"
                  className="text-blue-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Certificación ISO
                </Link>
              </li>
              <li>
                <Link
                  to="/contacto"
                  className="text-blue-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Trabaja con Nosotros
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 4 - Contacto */}
          <div>
            <h3 className="text-white font-bold mb-4 text-lg">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-blue-100 text-sm">
                <i className="ri-phone-line mt-1"></i>
                <div>
                  <p>+57 (604) 4488476</p>
                  <p>+57 (316) 619 89 97</p>
                </div>
              </li>
              <li className="flex items-start gap-2 text-blue-100 text-sm">
                <i className="ri-mail-line mt-1"></i>
                <p>juan.espinosa@irm.com.co</p>
              </li>
              <li className="flex items-start gap-2 text-blue-100 text-sm">
                <i className="ri-map-pin-line mt-1"></i>
                <p>Sabaneta, Colombia</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Barra inferior */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <p className="text-blue-100 text-sm">
              © 2026 IRM - Ingeniería, Repuestos y Mantenimiento
            </p>

            {/* Redes sociales */}
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border-2 border-white/40 rounded-full hover:bg-white hover:text-[#1A3A52] transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border-2 border-white/40 rounded-full hover:bg-white hover:text-[#1A3A52] transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border-2 border-white/40 rounded-full hover:bg-white hover:text-[#1A3A52] transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center border-2 border-white/40 rounded-full hover:bg-white hover:text-[#1A3A52] transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
            </div>

            {/* Links legales */}
            <div className="flex gap-4 text-blue-100 text-sm">
              <a
                href="#"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Política de Privacidad
              </a>
              <span>|</span>
              <a
                href="#"
                className="hover:text-white transition-colors cursor-pointer"
              >
                Términos de Servicio
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
